import { render } from "./AttendanceMethods.vue?vue&type=template&id=113bc3ad&scoped=true"
const script = {}

import "./AttendanceMethods.vue?vue&type=style&index=0&id=113bc3ad&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-113bc3ad"]])

export default __exports__